<template>
    <div class="item item-placeholder">
        <div
            :class="classNumber"
            class="number"
        >
            {{ index + 1 }}
        </div>

        <div class="title-description">
            <h3 class="title">
                {{ title }}
            </h3>

            <div class="description">
                {{ description }}
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import type {
    PlaceholderPersonalization,
    PlaceholderRing,
    PlaceholderStone,
} from '@/components/rings/ring-builder/RingBuilder.vue'
import { assertNever } from '@/helpers'
import { useRingBuilder } from '@/composables/useRingBuilder'

type PlaceholderItem =
    | PlaceholderRing
    | PlaceholderStone
    | PlaceholderPersonalization

const props = defineProps<{
    index: number
    data: PlaceholderItem
    isFinal?: boolean
}>()

const { totalSaleAmountFormatted } = useRingBuilder()

// TODO translate
const title = computed(() => {
    const data = props.data

    switch (data.__typename) {
        case 'placeholder-ring':
            return 'Ring design'
        case 'placeholder-stone':
            return 'Centre stone'
        case 'placeholder-personalization':
            return 'View your ring'
        default:
            return assertNever(data, '')
    }
})

// TODO translate
const description = computed(() => {
    const data = props.data

    switch (data.__typename) {
        case 'placeholder-ring':
            return 'Browse our collection'
        case 'placeholder-stone':
            return 'Find the perfect stone'
        case 'placeholder-personalization':
            return `Total: ${totalSaleAmountFormatted.value}`
        default:
            return assertNever(data, '')
    }
})

const classNumber = computed(() => ({
    'final': props.isFinal,
}))
</script>

<style lang="scss" scoped src="./ringBuilderItem.scss"></style>
<style lang="scss" scoped>
.item-placeholder {
    .number {
        margin-right: 20px;
        flex: 0 0 36px;
        width: 36px;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 3px;
        background-color: $white;
        color: $blue;
        font-family: $parcel-font-stack;
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        line-height: 125%;
        text-align: center;
        letter-spacing: 0.01em;
        font-feature-settings:
            'pnum' on,
            'lnum' on;

        &.final {
            background-color: $blue;
            color: $white;
        }
    }
}
</style>
